import { put, call, takeLatest } from "redux-saga/effects";
import { getMyCharDocsData, getFAQ, getPrivacyHealthPlanData, getPrivacyMyBswhData, getPrivacyMyChartData } from "../api/docsApi";
import { logAPI } from "../api/andyliticsApi";
import * as types from "../constants/actionTypes";

export default function* docsSaga() {
    yield takeLatest(types.LOAD_DOCS_DATA, handleDocs);
    yield takeLatest(types.GET_PRIVACY_HEALTHPLAN_TEXT, handlePrivacyHealthPlanText);
    yield takeLatest(types.GET_PRIVACY_MYBSWH_TEXT, handlePrivacyMyBswhText);
    yield takeLatest(types.GET_PRIVACY_MYCHART_TEXT, handlePrivacyMyChartText);
    yield call(loadFAQ);
}

function* loadFAQ() {
    const start = new Date();
    try {
        let faq = yield call(getFAQ);
        faq = JSON.parse(faq);
        if (faq && faq.length > 0) {
            faq.forEach(item => item.questionText = item.questionText.trim());
        }
        yield put({ type: types.FAQ_SUCCESS, faq });
        logAPI("MBHWeb.Saga.SSO.LoadFAQ", start, null);
    }
    catch (error) {
        yield put({ type: types.FAQ_FAILURE, error });
        logAPI("MBHWeb.Saga.SSO.LoadFAQ.Failure", start, null, JSON.stringify(error));
    }
}

export function* handleDocs(payload) {
    try {
        const docsData = yield call(getMyCharDocsData, payload.payload.docId, payload.payload.localization);
        yield [put({ type: types.LOAD_DOCS_DATA_SUCCESS, docsData })];
    }
    catch (error) {
        console.error(error);
        yield put({ type: types.LOAD_DOCS_DATA_FAILURE, error });
    }
}

export function* handlePrivacyHealthPlanText(payload) {
    try {
        const healthPlanPrivacydata = yield call(getPrivacyHealthPlanData, payload);
        yield [put({ type: types.GET_PRIVACY_HEALTHPLAN_TEXT_SUCCESS, healthPlanPrivacydata })];
    }
    catch (error) {
        console.error(error);
        yield put({ type: types.GET_PRIVACY_HEALTHPLAN_TEXT_FAILURE, error });
    }
}

export function* handlePrivacyMyBswhText(payload) {
    try {
        const bswhPrivacydata = yield call(getPrivacyMyBswhData, payload);
        yield [put({ type: types.GET_PRIVACY_MYBSWH_TEXT_SUCCESS, bswhPrivacydata })];
    }
    catch (error) {
        console.error(error);
        yield put({ type: types.GET_PRIVACY_MYBSWH_TEXT_FAILURE, error });
    }
}

export function* handlePrivacyMyChartText(payload) {
    try {
        const myChartPrivacyData = yield call(getPrivacyMyChartData, payload);
        yield [put({ type: types.GET_PRIVACY_MYCHART_TEXT_SUCCESS, myChartPrivacyData })];
    }
    catch (error) {
        console.error(error);
        yield put({ type: types.GET_PRIVACY_MYCHART_TEXT_FAILURE, error });
    }
}